var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeAllFeatures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_173_2",
    "data-name": "Component 173 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.117,
    height: 21.898,
    viewBox: "0 0 25.117 21.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5049",
    "data-name": "Path 5049",
    d: "M16.858,25.4V19.5H3V9.4H16.858V3.5L28.117,14.449Z",
    transform: "translate(-3 -3.5)",
    fill: "#6d6d6d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeAllFeatures);
export default __webpack_public_path__ + "static/media/see-all-features.8a5dfd2d9aed104f94390c5c96de9bc8.svg";
export { ForwardRef as ReactComponent };